export const CONTACT = {
  phone: "708-603-7046",
  phoneHref: "tel:+17086037046",
  email: "info@aftermathmgmt.com",
  address: "425 Mannheim Rd, Bellwood, IL 60104",
  area: "Bellwood & Greater Chicagoland",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1691548970765-f8335acd7141?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxyZXN0b3JhdGlvbiUyMHdvcmtlciUyMHByb3RlY3RpdmUlMjBzdWl0JTIwY2xlYW51cHxlbnwwfHx8fDE3ODYyOTI0MjF8MA&ixlib=rb-4.1.0&q=85",
  water: "https://images.unsplash.com/photo-1772939653926-dba18c5271b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHx3YXRlciUyMGRhbWFnZSUyMHJlc3RvcmF0aW9uJTIwZmxvb2RlZCUyMGhvbWUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODYyOTI0MjB8MA&ixlib=rb-4.1.0&q=85",
  fire: "https://images.unsplash.com/photo-1767884163989-0ccfd3492c39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxmaXJlJTIwZGFtYWdlJTIwYnVybnQlMjBob3VzZSUyMGludGVyaW9yJTIwc21va2V8ZW58MHx8fHwxNzg2MjkyNDIxfDA&ixlib=rb-4.1.0&q=85",
  mold: "https://images.unsplash.com/photo-1681812508658-12c52bf91fd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxyZXN0b3JhdGlvbiUyMHdvcmtlciUyMHByb3RlY3RpdmUlMjBzdWl0JTIwY2xlYW51cHxlbnwwfHx8fDE3ODYyOTI0MjF8MA&ixlib=rb-4.1.0&q=85",
  storm: "https://images.unsplash.com/photo-1682351889381-9bbc98ebca86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxzdG9ybSUyMGRhbWFnZSUyMGRpc2FzdGVyJTIwaG91c2UlMjBkZXN0cnVjdGlvbnxlbnwwfHx8fDE3ODYyOTI0MjB8MA&ixlib=rb-4.1.0&q=85",
  process: "https://images.unsplash.com/photo-1628689814107-61cff402f7cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxyZXN0b3JhdGlvbiUyMHdvcmtlciUyMHByb3RlY3RpdmUlMjBzdWl0JTIwY2xlYW51cHxlbnwwfHx8fDE3ODYyOTI0MjF8MA&ixlib=rb-4.1.0&q=85",
  roof: "https://images.unsplash.com/photo-1633759593085-1eaeb724fc88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxyZXNpZGVudGlhbCUyMHJvb2YlMjBzaWRpbmclMjBob3VzZSUyMGV4dGVyaW9yJTIwaW5zcGVjdGlvbnxlbnwwfHx8fDE3ODYzMTcyODh8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "water",
    num: "01",
    title: "Water Damage",
    tag: "Extraction · Dry-out",
    image: IMAGES.water,
    desc: "Rapid extraction, structural drying and moisture mapping to stop damage before it spreads.",
    points: ["Emergency water extraction", "Structural dehumidification", "Moisture mapping & monitoring"],
  },
  {
    id: "fire",
    num: "02",
    title: "Fire & Smoke",
    tag: "Soot · Odor",
    image: IMAGES.fire,
    desc: "Full soot removal, smoke-odor neutralization and content restoration after fire loss.",
    points: ["Soot & residue removal", "Thermal odor treatment", "Content pack-out & cleaning"],
  },
  {
    id: "mold",
    num: "03",
    title: "Mold Remediation",
    tag: "Containment · Air",
    image: IMAGES.mold,
    desc: "Certified containment and safe removal that restores healthy indoor air quality.",
    points: ["Containment barriers", "HEPA air scrubbing", "Antimicrobial treatment"],
  },
  {
    id: "storm",
    num: "04",
    title: "Storm & Disaster",
    tag: "Board-up · Debris",
    image: IMAGES.storm,
    desc: "Emergency board-up, debris removal and full-scale rebuild after catastrophic events.",
    points: ["24/7 emergency board-up", "Debris & tarp management", "Reconstruction services"],
  },
];

export const PROCESS = [
  { num: "01", title: "Immediate Response", desc: "Call and a certified crew mobilizes 24/7. We assess, secure the site, and stop active damage within the hour." },
  { num: "02", title: "Inspect & Document", desc: "We map the loss, document every detail for your insurance, and build a clear, no-surprise scope of work." },
  { num: "03", title: "Restore & Rebuild", desc: "From extraction and drying to full reconstruction, we return your property to its pre-loss condition, or better." },
];

export const STATS = [
  { value: "24/7", label: "Emergency Response" },
  { value: "<60", label: "Minute Arrival Target" },
  { value: "1,200+", label: "Properties Restored" },
  { value: "IICRC", label: "Certified Crews" },
];
